/* Blomman-only quick choices. Remaining pages use the theme's server-rendered cards. */
if (!customElements.get('gv-blomman-categories')) {
  customElements.define('gv-blomman-categories', class extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById('product-grid-ajax');
      if (!this.grid || this.initialized) return;
      this.initialized = true;
      this.category = 'all';
      this.revision = 0;
      this.status = this.querySelector('[role="status"]');
      this.observer = new MutationObserver(() => {
        const state = this.grid.querySelector('[data-gv-grid-state]');
        if (state !== this.state) {
          this.readState();
          if (this.category !== 'all') this.select(this.category);
        } else if (!this.loading) {
          this.apply();
        }
      });
      this.readState();
      this.observer.observe(this.grid, { childList: true });
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-category]');
        if (button) this.select(button.dataset.category);
      });
      this.hidden = false;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }

    readState() {
      this.controller?.abort();
      this.revision += 1;
      this.state = this.grid.querySelector('[data-gv-grid-state]');
      this.next = this.state?.dataset.next || '';
      this.loading = null;
      this.grid.removeAttribute('aria-busy');
      this.status.textContent = '';
      this.status.removeAttribute('data-notice');
      this.querySelector('.gv-blomman-empty').hidden = true;
    }

    async select(category) {
      this.category = category;
      this.querySelectorAll('button[data-category]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.category === category));
      });
      if (category === 'all' && !this.loading) {
        this.apply();
        return;
      }
      const revision = this.revision;
      this.status.textContent = this.dataset.loading;
      this.status.setAttribute('data-notice', '');
      this.grid.setAttribute('aria-busy', 'true');
      document.getElementById('pagination-ajax').hidden = true;
      try {
        this.loading ||= this.loadRemaining();
        await this.loading;
        if (revision !== this.revision) return;
        this.loading = null;
        this.grid.removeAttribute('aria-busy');
        this.apply();
      } catch (error) {
        if (revision !== this.revision || error.name === 'AbortError') return;
        this.loading = null;
        this.grid.removeAttribute('aria-busy');
        this.category = 'all';
        this.apply();
        this.status.textContent = this.dataset.error;
        this.status.setAttribute('data-notice', '');
      }
    }

    async loadRemaining() {
      this.controller = new AbortController();
      const revision = this.revision;
      const seenPages = new Set();
      while (this.next) {
        const url = new URL(this.next, location.href);
        if (url.origin !== location.origin || seenPages.has(url.href)) throw new Error('Invalid pagination');
        seenPages.add(url.href);
        const response = await fetch(url.href, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection could not be loaded');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = html.getElementById('product-grid-ajax');
        const nextState = nextGrid?.querySelector('[data-gv-grid-state]');
        if (!nextState) throw new Error('Missing collection state');
        if (revision !== this.revision) return;
        const ids = new Set([...this.grid.querySelectorAll('[data-gv-product-id]')].map(card => card.dataset.gvProductId));
        this.observer.disconnect();
        nextGrid.querySelectorAll('[data-gv-product-id]').forEach(card => {
          if (!ids.has(card.dataset.gvProductId)) {
            this.grid.append(document.importNode(card, true));
            ids.add(card.dataset.gvProductId);
          }
        });
        this.observer.observe(this.grid, { childList: true });
        this.next = nextState.dataset.next || '';
      }
    }

    apply() {
      let count = 0;
      const seen = new Set();
      this.grid.querySelectorAll('[data-gv-product-id]').forEach(card => {
        if (seen.has(card.dataset.gvProductId)) {
          card.remove();
          return;
        }
        seen.add(card.dataset.gvProductId);
        const visible = this.category === 'all' || card.dataset.gvCategory === this.category;
        card.hidden = !visible;
        if (visible) count += 1;
      });
      const all = this.category === 'all';
      const text = (count === 1 ? this.dataset.one : this.dataset.other).replace('__COUNT__', count);
      const countElement = document.getElementById('products-count-ajax');
      if (countElement) countElement.textContent = all ? this.state.dataset.countText : text;
      const applyCount = document.getElementById('apply-count');
      if (applyCount) applyCount.textContent = all ? this.state.dataset.countText : text;
      document.getElementById('pagination-ajax').hidden = !all || !this.next;
      this.querySelector('.gv-blomman-empty').hidden = all || count > 0;
      this.querySelectorAll('button[data-category]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.category === this.category));
      });
      this.status.textContent = all ? '' : text;
      this.status.removeAttribute('data-notice');
    }
  });
}
